import { useQuery } from "@tanstack/react-query";

import { api } from "./client";
import { queryKeys } from "./keys";
import type { Me } from "./types";

export function useMe() {
  return useQuery({
    queryKey: queryKeys.me,
    queryFn: ({ signal }) => api.get<Me>("/v1/me", undefined, signal),
    staleTime: 5 * 60 * 1000,
  });
}
